import { Logger } from "./logger";
import ShopPromoLarge from "./large/shoppromo_large";
import ShopPromoSmall from "./small/shoppromo_small";
import PromoBrandShopPromo from "./brand/promo_brandshoppromo";
import BrandhubDiscoveryCard from "./brandhub/discovery_card";
import { onMount } from "@otto-ec/global-resources/dom";

onMount(".promo_shoppromo-large--container", (element) => {
    Logger.group("[FT3 promo shoppromo]");
    Logger.count("Large Shoppromo Invocation");
    new ShopPromoLarge(element);
    Logger.groupEnd();
});

onMount(".promo_shoppromo-small--container", (element) => {
    Logger.group("[FT3 promo shoppromo]");
    Logger.count("Small Shoppromo Invocation");
    new ShopPromoSmall(element);
    Logger.groupEnd();
});

onMount(".promo_brandshoppromo--container", (element) => {
    Logger.group("[FT3 promo shoppromo]");
    Logger.count("Brandshoppromo Invocation");
    new PromoBrandShopPromo(element);
    Logger.groupEnd();
});

onMount(".promo_brandhub_discovery_card__container", (element) => {
    Logger.group("[FT3 promo shoppromo]");
    Logger.count("Brandhub Discovery Card Invocation");
    new BrandhubDiscoveryCard(element);
    Logger.groupEnd();
});
